<template>
  <el-card style="margin-top: 30px" v-loading="loading">
    <div style="display: flex;justify-content: space-between; margin-bottom: 20px">
      <h3 style="margin-top: 0; margin-bottom: 0">Настройки процедуры</h3>
      <div style="display: flex">

        <import-modal
          entity="raise_rss_ranges_by_bands"
          title="Импорт диапазонов оплаты труда по бендам/проф.группам"
          :data="{procedure_id: procedure.id}"
          close-on-success
          @import-finished="importFinished"
        >
          <template v-slot:reference>
            <el-button
              size="mini"
              icon="fas fa-file-import"
              @click=""
            >
              Импорт диапазонов
            </el-button>

          </template>
        </import-modal>

        <el-button
          style="margin-left: 20px"
          size="mini"
          icon="fas fa-upload"
          @click="exportToExcel"
        >
          Экспорт пользователей
        </el-button>
      </div>
    </div>


    <div style="margin-bottom: 20px">
      <div>Бюджетный % оплаты труда</div>
      <click-to-edit
        style="width:200px"
        placeholder=""
        v-model="meta.budget_percent_for_raise"
        digits-only
        @input="saveMeta"
      ></click-to-edit>
    </div>



    <div class="smz-table-name">Диапазон % повышения оплаты труда</div>

    <table class="smz-base-table">
      <thead>
      <tr>
        <th style="width: 40%">Итоговая оценка эффективности деятельности</th>
        <th style="width: 20%">Min</th>
        <th style="width: 20%">Middle</th>
        <th style="width: 20%">Max</th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="evaluation in evaluations[$companyConfiguration.settings.getEnum('evaluation_types')['TYPE_FINAL_EFFICIENCY']]">
        <td class="smz-base-table-cell-gray">{{ evaluation.name }}</td>
        <td>
          <click-to-edit
            v-if="meta.raise_percent_range"
            placeholder=""
            v-model="meta.raise_percent_range.min[evaluation.id]"
            digits-only
            @input="saveMeta"
          ></click-to-edit>
        </td>
        <td>
          <click-to-edit
            v-if="meta.raise_percent_range"
            placeholder=""
            v-model="meta.raise_percent_range.middle[evaluation.id]"
            digits-only
            @input="saveMeta"
          ></click-to-edit>
        </td>
        <td>
          <click-to-edit
            v-if="meta.raise_percent_range"
            placeholder=""
            v-model="meta.raise_percent_range.max[evaluation.id]"
            digits-only
            @input="saveMeta"
          ></click-to-edit>
        </td>
      </tr>
      </tbody>
    </table>



    <div class="smz-table-name" style="margin-top: 30px">Расчет корректировочного фактора</div>

    <div style="display: flex; gap: 20px">
      <user-unique-prop-values-select
        placeholder="Цех"
        style="width: 300px"
        v-model="filters.workshops"
        prop="workshop"
        multiple
        @selected="filtersChanged"
      ></user-unique-prop-values-select>
      <user-unique-prop-values-select
        placeholder="Должность"
        style="width: 300px"
        v-model="filters.positions"
        prop="position"
        multiple
        @selected="filtersChanged"
      ></user-unique-prop-values-select>
      <user-unique-prop-values-select
        placeholder="Дирекция"
        style="width: 300px"
        v-model="filters.directions"
        prop="direction"
        multiple
        @selected="filtersChanged"
      ></user-unique-prop-values-select>
    </div>
    <div style="margin-top: 20px; margin-bottom:20px">Корректировочный фактор: {{ meta.correction_factor }}</div>


    <el-popconfirm
      v-if="selectedUsers.length"
      confirm-button-text='Да'
      cancel-button-text='нет'
      icon="el-icon-question"
      title="Вы уверены, что хотите удалить пользователей?"
      @confirm="deleteSelectedUsers"
    >
      <el-button
        slot="reference"
        size="mini"
        type="danger"
        icon="fas fa-trash"
      >
        Удалить отмеченные
      </el-button>
    </el-popconfirm>

    <el-table
      style="width: 100%; margin-top: 5px;"
      :data="procedureUsers"
      empty-text="Нет пользователей"
      v-loading="loadingUsers"
      size="mini"
      border
      :row-key="(row) => row.user_id"
      @selection-change="selectionChanged"
    >
      <el-table-column type="selection" reserve-selection width="39"></el-table-column>
      <el-table-column label="ФИО">
        <template v-slot="scope">
          <div v-if="scope.row.historyUser">{{ scope.row.historyUser.last_name }} {{ scope.row.historyUser.first_name }} {{ scope.row.historyUser.middle_name }}</div>
          <div v-else>Нет данных из истории</div>
        </template>
      </el-table-column>
      <el-table-column label="Личный номер">
        <template v-slot="scope">
          {{ scope.row.historyUser ? scope.row.historyUser.persnum : 'Нет данных из истории' }}
        </template>
      </el-table-column>
      <el-table-column label="Дирекция">
        <template v-slot="scope">
          {{ scope.row.historyUser ? scope.row.historyUser.direction : 'Нет данных из истории' }}
        </template>
      </el-table-column>
      <el-table-column label="Цех" width="60">
        <template v-slot="scope">
          {{ scope.row.historyUser ? scope.row.historyUser.workshop : 'Нет данных из истории' }}
        </template>
      </el-table-column>
      <el-table-column label="Должность">
        <template v-slot="scope">
          {{ scope.row.historyUser ? scope.row.historyUser.position : 'Нет данных из истории' }}
        </template>
      </el-table-column>
      <el-table-column label="Оклад сотрудника" width="100">
        <template v-slot="scope">
          <click-to-edit
            v-model="scope.row.current_salary"
            :number-format="{decimals: 2, space:true}"
            placeholder=""
            digits-only
            @input="saveProcedureUserSalary(scope.row)"
          ></click-to-edit>
        </template>
      </el-table-column>
      <el-table-column label="Итоговая оценка эффективности">
        <template v-slot="scope">
          {{ evaluations[4] ? evaluations[4].find(e=>e.id===scope.row.evaluate_final_efficiency_id).name : '' }}
        </template>
      </el-table-column>
      <el-table-column label="Оклад сотрудника * бюджетный % повышения">
        <template v-slot="scope">
          {{ scope.row.salary_on_budget_percent_for_raise | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column label="Ср. % на повышение ОТ по оценке до корр. фактора">
        <template v-slot="scope">
          {{ scope.row.average_percent_to_raise_before_correction_factor | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column label="Оклад сотрудника * Ср. рекоменд. % до корр. фактора">
        <template v-slot="scope">
          {{ scope.row.salary_on_average_percent_to_raise_before_correction_factor | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column label="Ср. % на повышение ОТ по оценкам эффективности после корректировки">
        <template v-slot="scope">
          {{ scope.row.average_percent_to_raise_after_correction_factor | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column label="Оклад сотрудника* Ср.  % после корректировки">
        <template v-slot="scope">
          {{ scope.row.salary_on_average_percent_to_raise_after_correction_factor | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column width="54">
        <template v-slot="scope">
          <el-popconfirm
            confirm-button-text='Да'
            cancel-button-text='нет'
            icon="el-icon-question"
            title="Вы уверены, что хотите удалить пользователя?"
            @confirm="deleteProcedureUser(scope.row)"
          >
            <el-button
              style="margin-right: 10px"
              slot="reference"
              class="table-action-button"
              type="default"
              round
              size="mini"
              icon="far fa-trash-alt"
            >
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>

    </el-table>

    <paginator
      :paginator.sync="paginator"
      @page-changed="getProcedureUsers"
    ></paginator>



    <div class="smz-table-name" style="margin-top: 35px">Диапазон рекомендованных % повышения оплаты труда после корр.фактора</div>

    <table class="smz-base-table">
      <thead>
      <tr>
        <th style="width: 40%">Итоговая оценка эффективности деятельности</th>
        <th style="width: 20%">Min</th>
        <th style="width: 20%">Middle</th>
        <th style="width: 20%">Max</th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="evaluation in evaluations[$companyConfiguration.settings.getEnum('evaluation_types')['TYPE_FINAL_EFFICIENCY']]">
        <td class="smz-base-table-cell-gray">{{ evaluation.name }}</td>
        <td>
          <click-to-edit
            v-if="meta.advice_raise_range"
            placeholder=""
            v-model="meta.advice_raise_range.min[evaluation.id]"
            digits-only
            @input="saveMeta"
          ></click-to-edit>
        </td>
        <td>
          <click-to-edit
            v-if="meta.advice_raise_range"
            placeholder=""
            v-model="meta.advice_raise_range.middle[evaluation.id]"
            digits-only
            @input="saveMeta"
          ></click-to-edit>
        </td>
        <td>
          <click-to-edit
            v-if="meta.advice_raise_range"
            placeholder=""
            v-model="meta.advice_raise_range.max[evaluation.id]"
            digits-only
            @input="saveMeta"
          ></click-to-edit>
        </td>
      </tr>
      </tbody>
    </table>




    <CompensationProcedureRaiseRssRangesByBands
      :procedure="procedure"
      ref="rangesComponent"
      style="margin-top: 35px"
    ></CompensationProcedureRaiseRssRangesByBands>


    <div style="margin-top:35px; display: flex; flex-direction: row-reverse; gap: 20px">
      <el-button
        size="mini"
        type="primary"
        icon="fas fa-calculator"
        @click="recountProcedure(()=> {getProcedureUsers()})"
      >
        Внести изменения
      </el-button>

      <el-popover
        placement="top"
        trigger="click"
      >
        <el-button
          slot="reference"
          style="margin-left:10px"
          class="table-action-button danger"
          type="text"
          round
          size="mini"
          icon="fas fa-info-circle"
        ></el-button>

        <div>Чтобы внесенные изменения отобразились в процедуре руководителей, нажмите на кнопку</div>
      </el-popover>
    </div>

  </el-card>
</template>

<script>

import requestSender from "@/api/base/requestSender";
import ClickToEdit from "@/components/ClickToEdit.vue";
import {paginator} from "@/mixins/paginator";
import {sorter} from "@/mixins/sorter";
import Paginator from "@/components/Paginator.vue";
import {ProcedureEditMixin} from "@/componentsCompany/smz/compensation/mixins/ProcedureEditMixin";
import UserUniquePropValuesSelect from "@/components/filters/users/UserUniquePropValuesSelect.vue";
import {downloader} from "@/mixins/downloader";
import ImportModal from "@/components/exportImport/ImportModal.vue";
import CompensationProcedureRaiseRssRangesByBands
  from "@/componentsCompany/smz/compensation/procedures/CompensationProcedureRaiseRssRangesByBands.vue";

export default {
  name: "RaiseRssTemplate",
  components: {
    CompensationProcedureRaiseRssRangesByBands,
    ImportModal, UserUniquePropValuesSelect, Paginator, ClickToEdit},
  mixins: [paginator, sorter, ProcedureEditMixin, downloader],
  props: {
    procedure: {type: Object, required: true},
  },

  data() {

    return {
      loading: false,
      loadingUsers: false,

      evaluations: {},
      meta: {},

      filters:{
        workshops:[],
        positions:[],
        directions:[],
      },
      procedureUsers: [],

      selectedUsers: [],

    }
  },

  mounted() {
    this.getEvaluations();
    this.getMeta();
    this.getProcedureUsers();
  },
  methods: {

    selectionChanged(newSelection) {
      this.selectedUsers = newSelection;
    },

    filtersChanged(){
      this.getProcedureUsers();
    },

    getProcedureUsers(){
      this.loadingUsers = true;
      requestSender('get', 'compensation-procedure-raise-rss/get-procedure-users', {
        procedure_id: this.procedure.id,
        ...this.filters,

        [this.sorter.param]: this.sorter.sort,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
        expand: 'historyUser'
      })
        .then(({data, paginator, sorter}) => {
          this.procedureUsers = data.procedure_users;
          this.paginatorFill(paginator);
          // this.sorterFill(sorter);
        })
        .finally(() => {
          this.loadingUsers = false;
        });
    },


    saveProcedureUserSalary(procedureUser){
      this.loadingUsers = true;
      requestSender('post', 'compensation-procedure-raise-rss/update-procedure-user-salary', {
        procedure_id: this.procedure.id,
        user_id: procedureUser.user_id,
        salary: procedureUser.current_salary,
      })
        .finally(() => {
          this.loadingUsers = false;
        });
    },

    deleteProcedureUser(procedureUser){
      this.loadingUsers = true;
      requestSender('post', 'compensation-procedure-raise-rss/delete-procedure-users', {
        procedure_id: this.procedure.id,
        user_ids: [procedureUser.user_id],
      })
        .finally(() => {
          this.getProcedureUsers();
        });
    },

    deleteSelectedUsers(){
      this.loadingUsers = true;
      requestSender('post', 'compensation-procedure-raise-rss/delete-procedure-users', {
        procedure_id: this.procedure.id,
        user_ids: this.selectedUsers.map(user => user.user_id),
      })
        .finally(() => {
          this.selectedUsers = [];
          this.getProcedureUsers();
        });
    },


    exportToExcel() {
      this.downloadFile(
        false,
        this.$api.exportImport.export,
        {
          entity: 'raise_rss_users',
          data: {
            procedure_id: this.procedure.id,
            ...this.filters,
          }}
      )
    },

    importFinished(){
      this.$refs.rangesComponent.getSalaryRanges();
    },

  },


}
</script>

<style lang="scss">


</style>